export default "__VITE_ASSET__BCwmBHBG__"